module.exports = __webpack_public_path__ + "static/media/caret-circle-left.11dfc2ba.svg";